var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"leiniao"},[_c('div',{staticClass:"rule",on:{"click":_vm.showRule}},[_vm._v("规则")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"active-btn",on:{"click":_vm.sumbit}})])])}
var staticRenderFns = []

export { render, staticRenderFns }